<template>
  <div class="form" v-e2e="'formulario-endereco-customizado'">
    <slot name="titulo">
      <p><strong>Qual o endereço?</strong></p>
    </slot>
    <br/>
    <div class="columns is-multiline is-2 mb-0">
      <div class="column is-3">
        <TrfCepInput
          label="CEP"
          id="form-endereco-cep"
          v-model="formData.cep"
          ref="campoEnderecoCep"
          v-e2e="'cep-form-endereco'"
          :required="required && dirtyState.cep"
          @cepInformations="setCepInformations"
          @update:isLoading="setLoadingCep"
        ></TrfCepInput>
      </div>
      <div class="column" :class="{'allow-markup-error': markupErrorisEnderecoInvalido}">
        <TrfInput
          label="Endereço"
          placeholder=""
          margin="0"
          maxLength="50"
          id="form-endereco-endereco"
          v-model="formData.endereco"
          ref="campoEnderecoEndereco"
          v-e2e="'endereco-form-endereco'"
          :required="false"
          :isDisabled="isLoadingCep"
        ></TrfInput>
        <p v-if="isEnderecoInvalido" class="error-message">
          Campo obrigatório.
        </p>
      </div>
      <div class="column is-narrow" :class="{'allow-markup-error': markupErrorisNumeroInvalido}">
        <TrfNumberInput
          class="mb-0"
          label="Número"
          placeholder=""
          margin="0"
          id="form-endereco-numero"
          v-model="formData.numero"
          maxLength="10"
          :desabilitarInput="formData.semNumero || isLoadingCep"
          ref="campoEnderecoNumero"
          v-e2e="'numero-form-endereco'"
          :required="false"
        ></TrfNumberInput>
        <p v-if="isNumeroInvalido" class="error-message">
          Campo obrigatório.
        </p>
      </div>
      <div class="column is-narrow mt-2">
        <TrfCheckbox
          class="pb-0 pt-5"
          label="Sem número"
          id="form-endereco-semnumero"
          v-model="formData.semNumero"
          ref="campoEnderecoSemNumero"
          v-e2e="'semNumero-form-endereco'"
          :required="false"
          @update:modelValue="$event => setSemNumero($event)"
        >
        </TrfCheckbox>
      </div>
      <div class="column is-12" :class="{'allow-markup-error': markupErrorisComplementoInvalido}">
        <TrfInput
          label="Complemento"
          placeholder=""
          margin="0"
          id="form-endereco-complemento"
          v-model="formData.complemento"
          ref="campoEnderecoComplemento"
          maxLength="60"
          v-e2e="'complemento-form-endereco'"
          :required="false"
          :isDisabled="isLoadingCep"
        ></TrfInput>
        <p v-if="isComplementoInvalido" class="error-message">
          Campo obrigatório.
        </p>
      </div>
      <div class="column is-3" :class="{'allow-markup-error': markupErrorisBairroInvalido}">
        <TrfInput
          label="Bairro"
          placeholder=""
          margin="0"
          id="form-endereco-bairro"
          v-model="formData.bairro"
          ref="campoEnderecoBairro"
          :maxLength="bairroMaxLength.toString()"
          v-e2e="'bairro-form-endereco'"
          :required="false"
          :isDisabled="isLoadingCep"
        ></TrfInput>
        <p v-if="isBairroInvalido" class="error-message">
          Campo obrigatório.
        </p>
      </div>
      <div class="column is-5" :class="{'allow-markup-error': markupErrorisCidadeInvalido}">
        <TrfInput
          label="Cidade"
          placeholder=""
          margin="0"
          id="form-endereco-cidade"
          v-model="formData.cidade"
          ref="campoEnderecoCidade"
          maxLength="100"
          v-e2e="'cidade-form-endereco'"
          :required="false"
          :isDisabled="isLoadingCep"
        ></TrfInput>
        <p v-if="isCidadeInvalido" class="error-message">
          Campo obrigatório.
        </p>
      </div>
      <div class="column is-2" :class="{'allow-markup-error': markupErrorisEstadoInvalido}">
        <TrfSelect
          :options="listagemUFs"
          :noOptionsText="'UFs não encontradas'"
          label="UF"
          idSelect="form-endereco-uf"
          @valueSelect="$event => setUF($event)"
          placeholder=""
          :required="false"
          ref="campoEnderecoUf"
          :loadingData="loadingSelects"
          :disabled="loadingSelects || isLoadingCep"
          v-e2e="'uf-form-endereco'"
        ></TrfSelect>
        <p v-if="isEstadoInvalido" class="error-message">
          Campo obrigatório.
        </p>
      </div>
      <div class="column is-2" :class="{'allow-markup-error': markupErrorisPaisInvalido}">
        <TrfSelect
          :options="listagemPaises"
          :noOptionsText="'Países não encontradas'"
          label="País"
          idSelect="form-endereco-pais"
          @valueSelect="$event => setPais($event)"
          placeholder=""
          :required="false"
          ref="campoEnderecoPais"
          :loadingData="loadingSelects"
          :disabled="loadingSelects || isLoadingCep"
          v-e2e="'pais-form-endereco'"
        ></TrfSelect>
        <p v-if="isPaisInvalido" class="error-message">
          Campo obrigatório.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { camposEnderecoStore } from '../../stateManagement/camposEndereco';
import Endereco from '../../views/Legalize/CadastroDeProcessos/Models/endereco.model';
import TrfSelect from '../Select/index.vue';
  
  export default {
    name: 'TrfFormularioBaseEnderecoFormulario',
    expose: ['inicializarCampos', 'limparCampos'],
    emits: ['update:form-data', 'set:validacao', 'is:mounted'],
    components: {
      TrfInput: defineAsyncComponent(() => import('../Input/index.vue')),
      TrfNumberInput: defineAsyncComponent(() => import('../Input/TrfNumberInput.vue')),
      TrfCheckbox: defineAsyncComponent(() => import('../Checkbox/index.vue')),
      TrfSelect,
      TrfCepInput: defineAsyncComponent(() => import('../Input/TrfCepInput.vue'))
    },
    props: {
      pIsDirty: {
        type: Boolean,
        default: false
      },
      pPreview: {
        type: Boolean,
        default: true
      },
      required: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        formData: new Endereco(),
        listagemUFs: [],
        listagemPaises: [],
        loadingSelects: true,
        isLoadingCep: false,
        camposEnderecoStore: camposEnderecoStore,
        bairroMaxLength: 50,
        dirtyState: {
          cep: this.pIsDirty,
          endereco: this.pIsDirty,
          numero: this.pIsDirty,
          semNumero: this.pIsDirty,
          complemento: this.pIsDirty,
          bairro: this.pIsDirty,
          cidade: this.pIsDirty,
          estado: this.pIsDirty,
          pais: this.pIsDirty
        }
      };
    },
    computed: {
      cepInternalValidation() {
        return !this.formData.cep && this.$refs.campoEnderecoCep.isComponenteValido
      },
      isInvalida() {
        return this.isCepInvalido || this.isEnderecoInvalido || this.isNumeroInvalido || this.isComplementoInvalido || this.isBairroInvalido || this.isCidadeInvalido || this.isEstadoInvalido || this.isPaisInvalido
      },
      isDirty: {
        get() {
          return this.dirtyState.cep && this.dirtyState.endereco && (this.dirtyState.numero || this.dirtyState.semNumero) && this.dirtyState.complemento && this.dirtyState.bairro && this.dirtyState.cidade && this.dirtyState.estado && this.dirtyState.pais;
        },
        set(valor) {
          for(let campo in this.dirtyState) {
            this.dirtyState[campo] = valor
          }
        }
      },
      isCepInvalido() {
        if (!this.required) return false;
        return this.dirtyState.cep && (!this.formData.cep || this.cepInternalValidation)
      },
      isEnderecoInvalido() {
        if (!this.required) return false;
        return this.dirtyState.endereco && !this.formData.endereco?.trim()
      },
      isNumeroInvalido() {
        if (!this.required) return false;
        return (this.dirtyState.numero || this.dirtyState.semNumero) && (!this.formData.numero && !this.formData.semNumero);
      },
      isComplementoInvalido() {
        if (!this.required) return false;
        return this.dirtyState.complemento && !this.formData.complemento?.trim()
      },
      isBairroInvalido() {
        if (!this.required) return false;
        return this.dirtyState.bairro && !this.formData.bairro?.trim()
      },
      isCidadeInvalido() {
        if (!this.required) return false;
        return this.dirtyState.cidade && !this.formData.cidade?.trim()
      },
      isEstadoInvalido() {
        if (!this.required) return false;
        return this.dirtyState.estado && !this.formData.estado
      },
      isPaisInvalido() {
        if (!this.required) return false;
        return this.dirtyState.pais && !this.formData.pais
      },
      markupErrorisCepInvalido() {
        return !this.pPreview && this.isCepInvalido
      },
      markupErrorisEnderecoInvalido() {
        return !this.pPreview && this.isEnderecoInvalido
      },
      markupErrorisNumeroInvalido() {
        return !this.pPreview && this.isNumeroInvalido
      },
      markupErrorisComplementoInvalido() {
        return !this.pPreview && this.isComplementoInvalido
      },
      markupErrorisBairroInvalido() {
        return !this.pPreview && this.isBairroInvalido
      },
      markupErrorisCidadeInvalido() {
        return !this.pPreview && this.isCidadeInvalido
      },
      markupErrorisEstadoInvalido() {
        return !this.pPreview && this.isEstadoInvalido
      },
      markupErrorisPaisInvalido() {
        return !this.pPreview && this.isPaisInvalido
      },
    },
    watch: {
      formData: {
        immediate: true,
        handler() {
          this.$emit('update:form-data', this.formData)
          if(this.required) {
            this.$emit('set:validacao', !this.isInvalida);
          }
        },
        deep: true
      },
      'camposEnderecoStore.isLoadingEstados': {
        immediate: true,
        handler() {
          if(!camposEnderecoStore.isLoadingEstados) {            
            this.listagemUFs = camposEnderecoStore.estados;
          }
        },
      },
      'camposEnderecoStore.isLoadingPaises': {
        immediate: true,
        handler() {
          if(!camposEnderecoStore.isLoadingPaises) {
            this.listagemPaises = camposEnderecoStore.paisesSigla; 
          }
        },
      },
      pIsDirty: {
        immediate: true,
        handler(novo) {
          this.isDirty = novo
          if(this.required && this.$refs.campoEnderecoCep) {
            this.$refs.campoEnderecoCep.verificarSeInputEstaVazio()
          }
        }
      },
      isInvalida: {
          immediate: true,
          handler(novo) {
              if(this.required) {
                  this.$emit('set:validacao', !novo);
              }
          }
      }
    },
    methods: {
      async iniciarCamposSelects() {
        this.loadingSelects = true;
        await camposEnderecoStore.adquirirTodosOsCampos();
        this.listagemUFs = camposEnderecoStore.estados;
        this.listagemPaises = camposEnderecoStore.paisesSigla;
        this.loadingSelects = false;
      },
      inicializarCampos(dados){
        this.formData.updateDados(dados);
        this.inicializarSelects(this.formData);
      },
      inicializarSelects(){
        this.selecionarEstado();
        this.selecionarPais();
      },
      selecionarValorDoFormulario(refNome, propriedadeFormulario) { 
        if(!this.$refs[refNome]) return;
        if(!this.formData[propriedadeFormulario]) return;
        
        this.$refs[refNome].selecionar(this.formData[propriedadeFormulario]);
      },
      selecionarEstado() {
        this.selecionarValorDoFormulario('campoEnderecoUf', 'estado');
      },
      selecionarPais() {
        this.selecionarValorDoFormulario('campoEnderecoPais', 'pais');
      },
      setCEP(valor) {
        this.formData.cep = valor;
      },
      setSemNumero(valor) {
        this.formData.numero = null;
        this.formData.semNumero = valor;
      },
      setUF(valor) {
        this.formData.estado = valor;
      },
      setPais(valor) {
        this.formData.pais = valor;
      },
      setEndereco(valor) {
        this.formData.endereco = valor;
      },
      setComplemento(valor) {
        this.formData.complemento = valor;
      },
      setBairro(valor) {
        this.formData.bairro = valor.slice(0, this.bairroMaxLength);
      },
      setCidade(valor) {
        this.formData.cidade = valor;
      },
      setNumero(valor) {
        this.formData.numero = valor;
      },
      limparCampos() {
        this.formData = new Endereco();
        this.$refs.campoEnderecoCep.limparInput();
        this.$refs.campoEnderecoCep.limparValidacao();
        this.$refs.campoEnderecoEndereco.limparInput();
        this.$refs.campoEnderecoEndereco.limparValidacao();
        this.$refs.campoEnderecoComplemento.limparInput();
        this.$refs.campoEnderecoComplemento.limparValidacao();
        this.$refs.campoEnderecoBairro.limparInput();
        this.$refs.campoEnderecoBairro.limparValidacao();
        this.$refs.campoEnderecoCidade.limparInput();
        this.$refs.campoEnderecoCidade.limparValidacao();
        this.$refs.campoEnderecoNumero.limparInput();
        this.$refs.campoEnderecoNumero.limparValidacao();
        this.formData.semNumero = false;
        this.$refs.campoEnderecoUf.limparSelect();
        this.$refs.campoEnderecoUf.limparValidacao();
        this.$refs.campoEnderecoPais.limparSelect();
        this.$refs.campoEnderecoPais.limparValidacao();
      },
      setCepInformations(cepInformations) {
        const uf = this.listagemUFs.find(uf => uf.label == cepInformations.uf);
        if(uf) {
          this.$refs.campoEnderecoUf.selecionar(uf.value);
        } else {
          this.$refs.campoEnderecoUf.limparSelect();
          this.$refs.campoEnderecoUf.limparValidacao();
          this.setUF(null);
        }
        if (this.listagemPaises.find(pais => pais.value == '105')) {
          this.$refs.campoEnderecoPais.selecionar('105');
        }

        this.setEndereco(cepInformations.logradouro);
        this.setComplemento(cepInformations.complemento);
        this.setBairro(cepInformations.bairro);
        this.setCidade(cepInformations.localidade);
        this.setNumero(cepInformations.numero);
      },

      setLoadingCep(valor) {
        this.isLoadingCep = valor;
      },
    },
    async mounted() {
      await this.iniciarCamposSelects();
      this.$emit('is:mounted', true)
    },
  };
  </script>
  <style lang="scss" scoped>
  .multiselect-econtador {
    margin: 0;
  }
  .columns.is-0 > .column, .columns.is-gapless > .column {
  padding-left: 0;
  padding-right: 0;
}
.columns.is-1 {
  margin-left:-0.25em;
  margin-right:-0.25em;
 & > .column {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  } 
}
.columns.is-2 > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.columns.is-3 > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.columns.is-4 > .column {
  padding-left: 1rem;
  padding-right: 1rem;
}
.columns.is-5 > .column {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.columns.is-6 > .column {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.columns.is-7 > .column {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.columns.is-8 > .column {
  padding-left: 2rem;
  padding-right: 2rem;
}
  </style>
  